'use strict';

window.CFC = window.CFC || {};
window.CFC.Search = (function($) {
  var loadMoreEnabled = true;
  
  function init() {
    $('.searchResults').on('click', '.searchResults__loadMore', function(e) {
      e.preventDefault();
      
      if (!loadMoreEnabled) { return; }
      loadMoreEnabled = false;
      
      var $results = $('.searchResults');
      var $loadMoreButton = $results.find('.searchResults__loadMore');
      
      var loadMoreUrl = $loadMoreButton.attr('href');
      
      if (loadMoreUrl.indexOf('card-pager-mode') === -1) {
        loadMoreUrl += '&card-pager-mode=content';
      }
      
      window.fetch(loadMoreUrl)
      .then(function(response) { return response.text(); })
      .then(function(body) {
        $loadMoreButton.closest('.searchResults__loadMoreWrap').remove();
        $results.append(body);
        loadMoreEnabled = true;
      });
    });
  }
  
  $(init);
})(jQuery);